<template>
<!-- #15122e -->
  <div id="schoolReport"  style="height: 100%; width: 100%; background: linear-gradient( #030D31, #143C94, #041332); overflow: auto;">
    <el-container style="height: auto">
      <el-header style="width: 100%; height: 7rem;">
        <el-row style="margin-top: 1.67rem;height: 2.48rem; background: linear-gradient(to right, rgba(7, 60, 133, 0), rgba(5, 56, 136, 0.8), rgba(7, 60, 133, 0)) ">
          <el-col :span="22">
            <el-row>
              <el-col :span="7" class="col23-8_1">
                <div></div>
              </el-col>
              <el-col :span="10" class="col23-8_2">
                <span>全国系统空调数字平台</span>
              </el-col>
              <el-col :span="7" class="col23-8_3">
                <div></div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="1">
            <el-dropdown @command="handleCommand" style="color:#ffffff; padding-top: 0.5rem">
              <span class="el-dropdown-link" >
                菜单<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu  slot="dropdown">
                <el-dropdown-item command="choose">项目选择</el-dropdown-item>
                <el-dropdown-item command="adminDealer" v-if="userName == 'menred'">经销商管理</el-dropdown-item>
                <el-dropdown-item command="Dealer" v-if="level == 1">系统设置</el-dropdown-item>
                <el-dropdown-item command="Dealer" v-if="level == 2">系统设置</el-dropdown-item>
                <el-dropdown-item command="password" v-if="userName != 'menred'">修改密码</el-dropdown-item>
                <el-dropdown-item command="exit">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="1" style="font-size: 1.13rem; color: #6A81FB; text-align: center">
            <img src="../.././../static/images/quanping-2.png" @click="size" style="cursor: pointer;">
          </el-col>
        </el-row>
      </el-header>
      <el-container style="width: 100%; padding-left: 1.5rem">
        <el-main style="padding: 0; margin-bottom: 1rem;">
          <el-row>
            <el-col :span="5" style="height: 37.5rem; border: 0.13rem solid #0E3E95;position: relative;">
              <el-row>
                <div class="biaoti">
                  <span>综合信息</span>
                </div>
              </el-row>
              <el-row style="margin-left: 3.56rem; margin-top: 1.44rem">
                <el-row style="margin-top: 2rem">
                  <el-col :span="7">
                    <img src="../../../static/images/shichang.png" alt="" style="width: 4.38rem; height: 4.38rem;">
                  </el-col>
                  <el-col :span="16">
                    <el-row style="width:7rem; height: 1.38rem; line-height: 1.38rem; font-size: 1rem; color: #ffffff; text-align: left; margin-bottom: 0.5rem">
                      <span>耗电统计数据</span>
                    </el-row>
                    <el-row style="text-align: left;">
                      <li v-for="item in deviceTotal" :key="item.index" class="shichang">
                        <span>{{item}}</span>
                      </li>
                      <span style="font-size: 0.75rem; color: #B4C6EC;">KWh</span>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row class="elrow">
                  <el-col :span="7">
                    <span class="span_1">项目数量</span>
                  </el-col>
                  <el-col :span="15" class="span_2" v-model="devicTableData">
                    <span>{{devicTableData.length}} </span>
                    <span>个</span>
                  </el-col>
                </el-row>
                <el-row class="elrow">
                  <el-col :span="7">
                    <span class="span_1">末端温控</span>
                  </el-col>
                  <el-col :span="15" class="span_2">
                    <span>{{devicTableData228.length}}</span>
                    <span>个</span>
                  </el-col>
                </el-row>
                <el-row class="elrow">
                  <el-col :span="7">
                    <span class="span_1">供能面积</span>
                  </el-col>
                  <el-col :span="15" class="span_2">
                    <span>{{mianji}}</span>
                    <span>㎡</span>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 1.75rem">
                  <el-row style="margin-bottom: 1rem">
                    <el-col :span="7">
                      <img src="../../../static/images/nenghao (1).png" alt="" style="width: 4.38rem; height: 4.38rem;">
                    </el-col>
                    <el-col :span="15" style="height: 4.38rem; line-height: 4.38rem; color: #ffffff; font-size: 1.06rem; text-align: left">
                      <span>日总耗电</span>
                    </el-col>
                  </el-row>
                  <el-row class="elrow">
                    <el-col :span="7">
                      <span class="span_1">电量</span>
                    </el-col>
                    <el-col :span="15" class="span_2">
                      <span>{{sum}}</span>
                      <span>KWh</span>
                    </el-col>
                  </el-row>
                </el-row>
              </el-row>
              <span class="border1"></span>
              <span class="border2"></span>
              <span class="border3"></span>
              <span class="border4"></span>
            </el-col>
            <el-col :span="11" style="height: 37.5rem; border: 0.13rem solid #0E3E95; margin: 0 1.19rem; position: relative;">
              <div id="map" style="width: 100%; height: 100%;"></div>
              <div style="width: 100%; position: absolute; top: 0; left: 0">
                <div class="biaoti" style="margin: 0 auto">
                  <span>地图定位项目</span>
                </div>
              </div>
              <span class="border1"></span>
              <span class="border2"></span>
              <span class="border3"></span>
              <span class="border4"></span>
            </el-col>
            <el-col :span="7" class="col5">
              <el-row style="height: 18.155rem; border: 0.13rem solid #0E3E95; margin-bottom: 1.19rem; position: relative;">
                <el-row style="margin-bottom: 2.31rem">
                  <div class="biaoti">
                    <span>设备状态统计</span>
                  </div>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div id="main" style="width: 15.5rem; height: 6.8rem;"></div>
                  </el-col>
                  <el-col :span="12">
                    <div id="main_1" style="width: 15 .5rem; height: 6.8rem"></div>
                  </el-col>
                </el-row>
                <el-row style="color: #ffffff; padding-left: 1.38rem; margin-top: 1.75rem">
                  <el-col :span="7">
                    <li class="state">
                      <span></span>
                      <span>{{devicTableData.length}}</span>
                    </li>
                    <li class="state_1">
                      <span></span>
                      <span>装机总量(台)</span>
                    </li>
                  </el-col>
                  <el-col :span="9">
                    <li class="state">
                      <span></span>
                      <span>{{jiantan}}</span>
                    </li>
                    <li class="state_1">
                      <span></span>
                      <span>累计减少碳排放总量(kg)</span>
                    </li>
                  </el-col>
                  <el-col :span="8">
                    <li class="state">
                      <span></span>
                      <span>{{jieneng}}</span>
                    </li>
                    <li class="state_1">
                      <span></span>
                      <span>累计总节能量(KWh)</span>
                    </li>
                  </el-col>
                </el-row>
                <span class="border1"></span>
                <span class="border2"></span>
                <span class="border3"></span>
                <span class="border4"></span>
              </el-row>
              <el-row style="height: 18.155rem; border: 0.13rem solid #0E3E95; position: relative;">
                <el-row>
                  <div class="biaoti">
                    <span>负荷预测·{{name}}</span>
                  </div>
                </el-row>
                <el-row>
                  <div id="main_2" style="width: 32rem; height: 15rem; margin: 0 auto"></div>
                </el-row>
                <div class="option">
                  <div class="yesterday">
                    <span>昨<br/>日</span>
                  </div>
                  <div class="today">
                    <span>今<br/>日</span>
                  </div>
                  <div class="tomorrow">
                    <span>上<br/>周</span>
                  </div>
                </div>
                <span class="border1"></span>
                <span class="border2"></span>
                <span class="border3"></span>
                <span class="border4"></span>
              </el-row>
            </el-col>
          </el-row>
        </el-main>
        <el-footer style="padding: 0; height: 19.13rem; margin-bottom: 2.06rem">
          <el-row>
            <el-col :span="5" style="height: 19.13rem; border: 0.13rem solid #0E3E95; position: relative;">
              <el-row>
                <div class="biaoti">
                  <span>项目运行状态</span>
                </div>
              </el-row>
              <el-row class="yunxing">
                <el-row>
                  <el-col :span="8">
                    <span>项目名称: </span>
                  </el-col>
                  <el-col :span="12">
                    <span>{{city}}&nbsp;{{name}}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>系统状态: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{getDpText(device_227,'power')}}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>工作模式: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{getDpText(device_227,'mode')}}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>除湿&nbsp;PTC: </span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="device_229.power == 1" style="color: #00EEFF">{{getDpText(device_229,'power')}}</span>
                    <span v-if="device_229.power == 0" style="color: #E65039">{{getDpText(device_229,'power')}}</span>
                    <span v-if="device_229.ptcsta == 1" style="color: #00EEFF">{{getDpText(device_229,'ptcsta')}}</span>
                    <span v-if="device_229.ptcsta == 0" style="color: #E65039">{{getDpText(device_229,'ptcsta')}}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>二氧化碳含量: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{device_229.snrco2 || '--' }}ppm</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>热泵设定温度: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{device_222.settemp || '--' }}°C</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>热泵供/回水温度: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{device_222.temp_b || '--' }}°C&nbsp;&nbsp;{{device_222.temp_o || '--' }}°C</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <span>二次供/回水温度: </span>
                  </el-col>
                  <el-col :span="8">
                    <span style="color: #00EEFF">{{device_227.mixtemp || '--' }}°C&nbsp;&nbsp;{{device_227.sphstemp || '--' }}°C</span>
                  </el-col>
                </el-row>
              </el-row>
              <span class="border1"></span>
              <span class="border2"></span>
              <span class="border3"></span>
              <span class="border4"></span>
            </el-col>
            <el-col :span="11" style="height: 19.13rem; margin: 0 1.19rem">
              <el-row>
                <el-col :span="12" style="height: 19.13rem; border: 0.13rem solid #0E3E95; background-color: rgba(0, 8, 47, 0.66); position: relative;">
                  <el-row style="margin-bottom: 0.2rem">
                    <div class="biaoti">
                      <span>室内空气质量</span>
                    </div>
                  </el-row>
                  <el-row style="
                      width: 16.5rem;
                      height: 16.5rem;
                      margin: 0 auto;
                      position: relative;
                  ">
                    <div
                      style="
                        width: 14.5rem;
                        height: 16.5rem;
                        color: #ffffff;
                        background: url('../../static/images/qlg.png') no-repeat;
                        background-size: 100%;
                        margin: 0 auto;
                      "
                    >
                      <div
                        style="
                          position: absolute;
                          top: 50%;
                          margin-top: -5rem;
                          left: 50%;
                          margin-left: -2.2rem;
                          width: 4.4rem;
                          text-align: center;
                          height: 10rem;
                          line-height:1.1rem;
                        "
                      >
                        <div :style="{'background-image':device_227.mode==2?'url(\'../../static/images/icon/heat.png\')':'url(\'../../static/images/icon/cool.png\')'}" style="margin:0 auto; margin-bottom:0.5rem; margin-top: 2rem;background:url('../../static/images/icon/cool.png') no-repeat;background-size:100% 100%; width:1rem;height:1rem"></div>
                        <span style="margin-left:0.5rem;font-size: 1.5rem">{{device_227.sethumi||'--'}}</span
                        ><span style="color: #ffffff">%</span><br />
                        <span style="margin-left:0.5rem;font-size: 1.5rem">{{qlgTemp || '--'}}</span
                        ><span style="color: #ffffff">℃</span><br>
                        <span style="font-size: 0.75rem">{{getDpText(device_227,'mode')}}</span>
                      </div>
                      <canvas id="qlg" style="width: 100%; height: 100%"></canvas>
                      <div
                        style="
                          position: absolute;
                          transform: rotate(-30deg);
                          font-size: 0.75rem;
                          font-weight: 100;
                          top: 3.7rem;
                          left: 5.5rem;
                        "
                      >
                        {{device_229.snrco2 || 0}}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          transform: rotate(-30deg);
                          top: 4.4rem;
                          left: 4.8rem;
                        "
                      >
                        CO2 ppm
                      </div>

                      <div
                        style="
                          position: absolute;
                          transform: rotate(30deg);
                          font-size: 0.75rem;
                          font-weight: 100;
                          top: 3.75rem;
                          left: 10.2rem;
                        "
                      >
                        {{ device_229['snrpm2.5'] || 0 }}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          transform: rotate(30deg);
                          top: 4.5rem;
                          left: 8.1rem;
                        "
                      >
                        PM2.5μg/m³
                      </div>

                      <div style="position: absolute; top: 7.7rem; left: 3.25rem; font-size: 0.75rem; font-weight: 100;">
                        {{ device_229.snrhumi || 0 }}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          top: 6.6rem;
                          left: 3.9rem;
                          word-break: break-all;
                          width: 1.2rem;
                        "
                      >
                        湿度 %
                      </div>

                      <div style="position: absolute; top: 7.7rem; left: 12.6rem; font-size: 0.75rem; font-weight: 100;">
                      {{ device_229.snrtemp || 0 }}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          top: 6.6rem;
                          left: 11.4rem;
                          word-break: break-all;
                          width: 1.2rem;
                        "
                      >
                        室温 ℃
                      </div>

                      <div
                        style="
                          position: absolute;
                          transform: rotate(30deg);
                          font-size: 0.75rem;
                          font-weight: 100;
                          top: 11.7rem;
                          left: 5.4rem;
                        "
                      >
                        {{device_227['fveff'] || '--'}}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          transform: rotate(30deg);
                          top: 10.9rem;
                          left: 4.5rem;
                        "
                      >
                        新风效率 %
                      </div>
                      <div
                        style="
                          width: 1rem;
                          height: 1rem;
                          position: absolute;
                          transform: rotate(30deg);
                          top: 12.4rem;
                          left: 4.9rem;
                          background: url('../../static/images/icon/rs.png');
                          background-size: 100% 100%;
                        "
                      ></div>

                      <div
                        style="
                          position: absolute;
                          transform: rotate(-30deg);
                          font-size: 0.75rem;
                          font-weight: 100;
                          top: 11.8rem;
                          left: 10.1rem;
                        "
                      >
                        {{ device_229[`filterAused`] || 0 }}
                      </div>
                      <div
                        style="
                          font-size: 0.75rem;
                          font-weight: 100;
                          position: absolute;
                          transform: rotate(-30deg);
                          top: 10.8rem;
                          left: 8.5rem;
                        "
                      >
                        滤网使用
                      </div>
                      <div
                        style="
                          width: 1.2rem;
                          height: 1.2rem;
                          position: absolute;
                          transform: rotate(-30deg);
                          top: 12.4rem;
                          left: 10.4rem;
                          background: url('../../static/images/icon/lw.png');
                          background-size: 100% 100% !important;
                        "
                      ></div>
                    </div>
                  </el-row>
                  <span class="border1"></span>
                  <span class="border2"></span>
                  <span class="border3"></span>
                  <span class="border4"></span>
                </el-col>
                <el-col :span="11" :offset="1" style="height: 19.13rem; border: 0.13rem solid #0E3E95; background-color: rgba(0, 8, 47, 0.66); position: relative;">
                  <el-row>
                    <div class="biaoti">
                      <span>室外天气 · {{city}}</span>
                    </div>
                  </el-row>
                  <el-row style="margin-top: 2.75rem">
                    <el-col :span="12">
                      <div class="rightUpBody" >
                        <div id="main_4" style="width: 12.5rem; height: 12.5rem;  overflow: hidden; position: relative;"></div>
                        <div
                          class="dataGrade1"
                          :style="{
                            backgroundColor: gradeColor2,
                            fontWeight: 'bold',
                          }">
                          {{ gradeWord2 }}
                      </div>
                      </div>
                    </el-col>
                    <el-col :span="12" style="padding-top: 1.5rem;">
                      <el-row>
                        <el-col :span="12" style="padding-top: 0.5rem">
                          <div class="col12">
                            <el-row class="span_3">温度</el-row>
                            <el-row class="span_6">
                              <span>{{weather.temp || '--' }}</span>
                              <span style="font-size: 0.68rem">°C</span>
                            </el-row>
                          </div>
                        </el-col>
                        <el-col :span="12" style="padding-top: 0.5rem">
                          <div class="col12">
                            <el-row class="span_3"><span>湿度</span></el-row>
                            <el-row class="span_6">
                              <span>{{weather.humidity || '--' }}</span>
                              <span style="font-size: 0.68rem">%</span>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row style="margin-top: 1.5rem;">
                        <el-col :span="12">
                          <div class="col12">
                            <el-row class="span_3"><span>风向</span></el-row>
                            <el-row class="span_6"><span>{{weather.wind || '--' }}</span></el-row>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="col12">
                            <el-row class="span_3"><span>风力</span></el-row>
                            <el-row class="span_6"><span>{{weather.winp || '--' }}</span></el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <span class="border1"></span>
                  <span class="border2"></span>
                  <span class="border3"></span>
                  <span class="border4"></span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7" style="height: 19.13rem; border: 0.13rem solid #0E3E95; background-color: rgba(0, 8, 47, 0.66); position: relative;">
              <el-row>
                <div class="biaoti">
                  <span>故障报警提示</span>
                </div>
              </el-row>
              <el-row style="margin: 1.75rem 1.38rem 0 1.2rem" class="table">
                <el-table
                  :data="tableData"
                  empty-text="暂无报警"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '0.75rem', 'color': '#1690F6' }"
                  :cell-style="{ height: '2.125rem', padding: '0', 'text-align': 'center', 'font-size': '0.75rem', 'color': '#ffffff'}"
                  style="width: 100%; padding-right: 2rem; overflow: auto;">
                  <el-table-column
                    prop="name"
                    label="项目名称"
                    >
                    <template slot-scope="scope">
                      {{scope.row.name || '无'}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="errmsg"
                    label="故障内容"
                    style="text-align: center"
                    >
                    <template slot-scope="scope">
                      {{scope.row.errmsg || '无'}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="createdtime"
                    label="故障时间">
                    <template slot-scope="scope">
                      {{scope.row.createdtime || '无'}}
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <span class="border1"></span>
              <span class="border2"></span>
              <span class="border3"></span>
              <span class="border4"></span>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Vue from 'vue'
import * as echarts from 'echarts'
const pm25LvlRange = new Array(0, 35, 75, 115, 150, 250, 999)
const pm2d5LvlColorArray1 = new Array(
  '#69CE03',
  '#FFD028',
  '#FE8700',
  '#FD0100',
  '#CC0100',
  '#960359',
  '#960359'
)
let myCharts
let myCharts_1
let myCharts_2
let myCharts_4
export default {
  name: 'Pandect',
  data () {
    return {
      projectLIST: [],
      projectid: '0547102c-3d94-4992-b65d-6571b3bac4c4',
      deviceAddress: [],
      deviceList: [],
      name: '',
      city: '',
      gradeWord2: '',
      gradeColor2: '#69CE03',
      weather: '',
      tableData: [
        {'name': '', 'errmsg': '', 'createdtime': ''}
      ],
      value1: [],
      timestamp: [],
      tomorrow: [],
      devicTableDataInnerid: [],
      deviceTotal: '',
      deviceAioY: [],
      deviceAioY1: [],
      deviceAioT: [],
      deviceAioT1: [],
      deviceTimeY: [],
      deviceTimeD: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      deviceTimeT: [],
      sum: '',
      sumN: '',
      mianji: '',
      people: '',
      Z: 1,
      L: true,
      jieneng: '',
      jiantan: '',

      Username: [],
      userName: '',
      level: 0,

      default: []
    }
  },
  computed: {
    devicTableData: function () {
      let dev = this.projectLIST.filter((item, index) => {
        return this.projectLIST.findIndex(item1 => item1.projectid == item.projectid && item1.protocolid == item.protocolid && (item.protocolid == 227 || item.protocolid == 150)) == index
      })
      if (dev && dev.length > 0) {
        return dev
      } else {
        return []
      }
    },
    devicTableData228: function () {
      let dev = this.projectLIST.filter((d) => {
        return d.protocolid == 228
      })
      if (dev && dev.length > 0) {
        return dev
      } else {
        return {}
      }
    },
    Acb: function () {
      let dev = this.deviceList.filter((d) => {
        return d.type == 'acb'
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    heatpump: function () {
      let dev = this.deviceList.filter((d) => {
        return d.type == 'heatpump'
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    Wenk: function () {
      let dev = this.devicTableData228.filter((d) => {
        return d.projectid == this.projectid
      })
      if (dev && dev.length > 0) {
        return dev.length
      } else {
        return 0
      }
    },
    device_227: function () {
      let dev = this.deviceList.filter((d) => {
        return d.protocolid == 227
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    qlgTemp: function () {
      if (this.device_227.innerid) {
        if (this.device_227.mode == 2) {
          return this.device_227.mixsettemp_h
        } else {
          return this.device_227.mixsettemp_c
        }
      } else {
        return ''
      }
    },
    device_222: function () {
      let dev = this.deviceList.filter((d) => {
        return d.protocolid == 222
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    device_229: function () {
      let dev = this.deviceList.filter((d) => {
        return d.protocolid == 229
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    }
  },
  mounted: function () {
    var self = this
    let Username = window.localStorage.getItem('customer')
    let project = window.localStorage.getItem('project')
    let projectid1 = []
    if (!Username) {
      this.$router.push({ name: 'Login' })
      return
    }
    self.Username = JSON.parse(Username)
    self.userName = self.Username.username
    self.level = self.Username.level
    if (self.userName == 'menred') {
      Vue.axios.post('/aio/dealer/project/device/list', {
        protocolid: [227, 150, 228],
        dealerid: self.Username.dealerid,
        showDP: false
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.projectLIST = res.data.msgbody
            let City
            if (project) {
              City = JSON.parse(project)
              self.projectid = City.projectid
            } else {
              City = self.devicTableData.filter(x => {
                return x.projectid == '0547102c-3d94-4992-b65d-6571b3bac4c4'
              })
              City = City[0]
            }
            self.default = City
            projectid1 = [self.projectid]
            setTimeout(function () {
              self.city = self.default.pcity || self.default.city || self.default.ip || '上海'
              self.name = self.default.aio_project_name || self.default.name
              self.state()
              self.state_1()
              self.project_list(self.projectid)
              self.loada(projectid1)
              self.buildWeatherReport_1(self.city)
              self.load()
              self.ditu()
              self.deviceErrcode()
            }, 1000)
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    } else {
      Vue.axios.post('/project/device/query', {
        protocolid: [227, 150, 228],
        showDP: true
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.projectLIST = res.data.msgbody
            let City
            if (project) {
              City = JSON.parse(project)
            } else {
              City = self.devicTableData[0]
            }
            self.default = City
            self.projectid = City.projectid
            self.city = City.pcity || City.city || City.ip
            self.name = City.aio_project_name || City.name
            projectid1 = [self.projectid]
            setTimeout(function () {
              self.state()
              self.state_1()
              self.project_list(self.projectid)
              self.loada(projectid1)
              self.buildWeatherReport_1(self.city)
              self.load()
              self.ditu()
              self.deviceErrcode()
            }, 1000)
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    }
    setTimeout(function () {
      self.loada(projectid1)
    }, 30 * 60 * 1000)
    const win_wid = window.innerWidth
    // 今天
    let timestamp1 = new Date(new Date().toLocaleDateString())
    timestamp1.getTime()
    // 昨天
    var today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    var end = new Date(today - 1000)
    var start = new Date(today - 3600 * 1000 * 24)
    // 上周
    var myDate = today
    myDate.setDate(myDate.getDay() == 0 ? myDate.getDate() - 6 : myDate.getDate() - (myDate.getDay() - 1))
    var predate = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1) // 获取今天23：59:59
    predate.setDate(predate.getDay() == 0 ? predate.getDate() - 6 : predate.getDate() - (predate.getDay() - 1)) // 上周周日
    // 上周一时间
    var premon = myDate.setDate(myDate.getDate() - 7)
    var presun = predate.setDate(predate.getDate() - 1)
    self.value1 = [start.Format('yyyy-MM-dd HH:mm:00'), end.Format('yyyy-MM-dd HH:mm:00')]
    self.tomorrow = [new Date(premon).Format('yyyy-MM-dd HH:mm:00'), new Date(presun).Format('yyyy-MM-dd HH:mm:00')]
    self.timestamp = [timestamp1.Format('yyyy-MM-dd HH:mm:00'), (new Date()).Format('yyyy-MM-dd HH:mm:00')]
    document.getElementsByTagName('html')[0].style.fontSize =
      (win_wid / 1920) * 16 + 'px'
    $(window).bind('resize load', function () {
      var win_wid = window.innerWidth
      document.getElementsByTagName('html')[0].style.fontSize =
      (win_wid / 1920) * 16 + 'px'
    }),
    this.Common.connentMqtt(this.Common.newGuid())
    setTimeout(function () {
      self.Common.mqttReceive(
        [
          'device/' + self.default.srcaddress + '/broadcast',
          'device/' + self.default.srcaddress + '/' +
            self.Common.mqttClientid
        ],
        function (msg) {
          // 主机只要收到消息就表明在线，70s内无消息则离线

          msg = JSON.parse(msg.payloadString)
          for (var key in msg) {
            if (key == 'dpchange' || key == 'devdpmsg') {
              self.uploadtime = new Date().Format('yyyy-MM-dd HH:mm:ss')
              var dev = self.projectLIST.filter((x) => {
                if (key == 'dpchange') {
                  return x.deviceid == msg.dpchange.devid
                } else {
                  return x.deviceid == msg.devdpmsg.devid
                }
              })
              if (dev && dev.length > 0) {
                if (msg.dpchange.dpid == 9000) {
                  dev[0].online = msg[key].data
                } else if (msg.dpchange.dpid == 9003) {
                } else if (msg.dpchange.dpid == 9009) {
                  console.log(msg.dpchange)
                  if (msg.dpchange.data == 0) {
                    dev[0].errmsg = ''
                  } else {
                    if (self.errorlist && self.errorlist.length > 0) {
                      let error = self.errorlist.filter((x) => {
                        return (
                          x.protocolid.indexOf(dev[0].protocolid) >= 0
                        )
                      })
                      if (error && error.length > 0) {
                        let err = error[0].errorlist.filter((e) => {
                          return e.code == msg.dpchange.data
                        })
                        if (err && err.length > 0) {
                          dev[0].errmsg = err[0].desc
                        } else {
                          dev[0].errmsg = '未知故障'
                        }
                      } else {
                        dev[0].errmsg = '未知故障'
                      }
                    } else {
                      dev[0].errmsg = '未知故障'
                    }
                  }
                } else {
                  let dp = dev[0].dplist.filter((d) => {
                    return d.dpid == msg[key].dpid
                  })
                  if (dp && dp.length > 0) {
                    if (
                      dp[0].name == 'lgtpwr' ||
                      dp[0].name == 'lnrdimpwr'
                    ) {
                      dev[0].power = msg[key].data
                    }
                    dev[0][dp[0].name] =
                      Math.round(msg[key].data * 10) / 10

                    if (dp[0].name == 'snrco2' || dp[0].name == 'snrpm2.5' || dp[0].name == 'snrtemp' || dp[0].name == 'snrhumi') {
                      self.draw()
                    }
                  }
                }
              }
            } else if (key == 'dpsync') {
              msg.dpsync.forEach((o) => {
                var dev = self.projectLIST.filter((x) => {
                  return x.deviceid == o.devid
                })
                if (dev && dev.length > 0) {
                  for (let key in o.dplist) {
                    if (key == '9000') {
                      dev[0].online = o.dplist[key]
                    } else if (key == '9003') {
                      dev[0].signal = o.dplist[key]
                    } else {
                      let dp = dev[0].dplist.filter((d) => {
                        return d.dpid == parseInt(key)
                      })
                      if (dp && dp.length > 0) {
                        if (
                          dp[0].name == 'lgtpwr' ||
                          dp[0].name == 'lnrdimpwr'
                        ) {
                          dev[0].power = o.dplist[key]
                        }
                        dev[0][dp[0].name] =
                          Math.round(o.dplist[key] * 10) / 10
                      }
                    }
                  }
                }
              })
            }
          }
        }
      )
      let obj = { getAllDevOnlineSta: {} }
      self.Common.mqttSend(
        self.default.srcaddress,
        obj,
        function (msg) {}
      )
      obj = { getAllDevAllDpSta: 'save' }
      self.Common.mqttSend(
        self.default.srcaddress,
        obj,
        function (msg) {}
      )
      obj = { sysheart: 'null' }
      self.Common.mqttSend(
        self.default.srcaddress,
        obj,
        function (msg) {}
      )
    }, 2000)
  },
  methods: {
    size () {
      let element = document.getElementById('schoolReport')
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen
      if (requestMethod) {
        requestMethod.call(element)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    // 地图
    ditu () {
      var self = this
      let arr = self.devicTableData
      const win_wid = window.innerWidth
      let map
      let marker = null
      // let address = JSON.parse(this.project.address); //项目经纬度数组
      let address = [120.929626, 27.958508]
      // console.log(JSON.parse(this.project.address))
      // 初始化
      var geocoder = new AMap.Geocoder({
        radius: 500 // 范围，默认：500

      })
      map = new AMap.Map('map', {
        zoom: 12, // 缩放比例
        // 俯视角度
        // pitch:50,
        // viewMode: '3D',
        center: address, // 地图中心点，这里填入项目经纬度数组
        mapStyle: 'amap://styles/darkblue' // 设置地图的显示样式
      })
      let hours = 0
      if (self.default.errorcode == 0 || self.default.errorcode == null) {
        if (self.defaulterrtime) {
          let deta = new Date().getTime() - new Date(self.default.errtime).getTime()
          hours = parseInt(deta / (1000 * 60 * 60))
        } else {
          let deta = new Date().getTime() - new Date(self.default.createdtime).getTime()
          hours = parseInt(deta / (1000 * 60 * 60))
        }
      } else {
        hours = 0
      }
      let imga = 'https://resource.mibee.cn/resource/' + (self.default.pic || 'dba06208-8bcd-4bfa-9478-18ebcda63264')
      let name = self.default.aio_project_name || self.default.name
      var content = []
      content.push(
        "<div style='width: 8.75rem; height: 11rem;padding-top: 0.3rem; padding-bottom: 0.3rem;border: solid 1px #3F56BC;border-radius: 0.5rem; color: #ffffff;background-color: rgba(21,18,46,0.9);'><div style='font-size: 0.8rem'><span>" + name + "</span></div><div style='width: 7.75rem; height: 4.09rem;margin-top: 0.5rem; margin-bottom: 0.8rem'><img style='width: 7.75rem; height: 4.09rem;margin-left: 0.5rem' src=" + imga + "></div><div style='text-align:left; padding-left: 0.5rem; font-size: 0.75rem; margin-top: 0.44rem'><span>温控数量：" + self.Wenk + "</span></div><div style='text-align:left; padding-left: 0.5rem;margin-top: 0.44rem;margin-bottom: 0.55rem; font-size: 0.75rem;'><span>已累计运行" + hours + '小时无故障</span></div></div>'
      )
      var infoWindow = new AMap.InfoWindow({
        isCustom: true,
        content: createInfoWindow(content.join('<br>')), // 传入 dom 对象，或者 html 字符串
        offset: new AMap.Pixel(18, -30)
      })
      let gaode1 = ''
      let gaode2 = ''
      if (self.default.location != null) {
        gaode1 = self.default.location.split(',')[0]
        gaode2 = self.default.location.split(',')[1]
      }
      infoWindow.open(map, [gaode1, gaode2])

      // 构建自定义信息窗体
      function createInfoWindow (content) {
        var info = document.createElement('div')
        // 可以通过下面的方式修改自定义窗体的宽高
        info.style.width = '10.75rem'
        var middle = document.createElement('div')
        middle.innerHTML = content
        info.appendChild(middle)
        return info
      }

      // 引入SimpleMarker，loadUI的路径参数为模块名中 'ui/' 之后的部分
      AMapUI.loadUI(['overlay/SimpleMarker', 'misc/MarkerList'],
        function (SimpleMarker, MarkerList) {
          var simpleMarker = new SimpleMarker({
            iconLabel: '',
            iconTheme: 'default',
            iconStyle: 'blue',
            map: map
          })
          var mak11
          var markerList = new MarkerList({
            // 关联的map对象
            map: map,
            // 置空默认的选中行为，后续监听selectedChanged中处理
            onSelected: null,
            // 返回数据项的Id
            getDataId: function (dataItem, index) {
              // index表示该数据项在数组中的索引位置，从0开始，如果确实没有id，可以返回index代替
              return dataItem.id
            },
            // 返回数据项的位置信息，需要是AMap.LngLat实例，或者是经纬度数组，比如[116.789806, 39.904989]
            getPosition: function (dataItem) {
              return dataItem.position
            },
            // 返回数据项对应的Marker
            getMarker: function (dataItem, context, recycledMarker) {
              // 存在可回收利用的marker
              if (recycledMarker) {
                // 直接更新内容返回
                recycledMarker.setLabel(label)
                return recycledMarker
              }
              if (context.id == 1000) {
                mak11 = new SimpleMarker({
                  iconLabel: '',
                  iconTheme: 'default',
                  iconStyle: 'blue',
                  map: map
                })
                return mak11
              } else {
                if (arr[context.id].errorcode != null && arr[context.id].errorcode != 0) {
                  var mak0 = new SimpleMarker({
                    // 前景文字
                    iconLabel: '',
                    // 图标主题
                    iconTheme: 'default',
                    // 背景图标样式
                    iconStyle: {
                      src: '../../../static/images/icon/point-r.png',
                      style: {
                        width: '1.63rem',
                        height: '1.63rem'
                      }
                    }
                  })
                  mak0.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                  return mak0
                } else {
                  if (arr[context.id].eonline) {
                    if (arr[context.id].online) {
                      if (arr[context.id].power == 1) {
                        if (arr[context.id].mode == 2 || arr[context.id].mode == 4) {
                          var mak = new SimpleMarker({
                            iconLabel: '',
                            iconTheme: 'default',
                            iconStyle: {
                              src: '../../../static/images/icon/point.png',
                              style: {
                                width: '1.63rem',
                                height: '1.63rem'
                              }
                            }
                          })
                          mak.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                          return mak
                        } else {
                          if (arr[context.id].mode == 1 || arr[context.id].mode == 3) {
                            var mak1 = new SimpleMarker({
                              iconLabel: '',
                              iconTheme: 'default',
                              iconStyle: {
                                src: '../../../static/images/icon/point-g.png',
                                style: {
                                  width: '1.63rem',
                                  height: '1.63rem'
                                }
                              }
                            })
                            mak1.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                            return mak1
                          }
                        }
                      } else {
                        var mak2 = new SimpleMarker({
                          iconLabel: '',
                          iconTheme: 'default',
                          iconStyle: {
                            src: '../../../static/images/icon/point-b.png',
                            style: {
                              width: '1.63rem',
                              height: '1.63rem'
                            }
                          }
                        })
                        mak2.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                        return mak2
                      }
                    } else {
                      var mak3 = new SimpleMarker({
                        iconLabel: '',
                        iconTheme: 'default',
                        iconStyle: {
                          src: '../../../static/images/point-s.png',
                          style: {
                            width: '1.63rem',
                            height: '1.63rem'
                          }
                        }
                      })
                      mak3.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                      return mak3
                    }
                  } else {
                    var mak4 = new SimpleMarker({
                      iconLabel: '',
                      iconTheme: 'default',
                      iconStyle: {
                        src: '../../../static/images/point-s.png',
                        style: {
                          width: '1.63rem',
                          height: '1.63rem'
                        }
                      }
                    })
                    mak4.setTitle(arr[context.id].aio_project_name || arr[context.id].name)
                    return mak4
                  }
                }
              }
            },
            markerEvents: ['click', 'mouseover', 'mouseout']
          })
          // 监听选中改变
          markerList.on('selectedChanged', function (event, changedInfo) {
            var selectedRecord = changedInfo.selected,
              unSelectedRecord = changedInfo.unSelected,
              marker
            if (selectedRecord) {
              mak11.hide()
              marker = selectedRecord.marker
              marker.hide()
              simpleMarker.setMap(marker.getMap())
              simpleMarker.setPosition(marker.getPosition())
              simpleMarker.show()

              // simpleMarker.setTitle(arr[selectedRecord.id].aio_project_name || arr[selectedRecord.id].name)
              // self.projectid = arr[selectedRecord.id].projectid
              // let projectid1 = [arr[selectedRecord.id].projectid]
              // self.city = arr[selectedRecord.id].pcity || arr[selectedRecord.id].city || arr[selectedRecord.id].ip || '上海'
              // self.buildWeatherReport_1(self.city)
              // self.project_list(self.projectid)
              // self.loada(projectid1)
              // self.name =arr[selectedRecord.id].aio_project_name || arr[selectedRecord.id].name
              window.localStorage.setItem('project', JSON.stringify(arr[selectedRecord.id]))
              self.$router.push({ name: 'Device' })
            } else {
              simpleMarker.hide()
            }
            if (unSelectedRecord) {
              marker = unSelectedRecord.marker
              marker.show()
            }
          })
          markerList.on('markerMouseover', function (event, record) {
            var hours = 0,
              marker
            marker = record.marker
            mak11.hide()
            if (record && marker) {
              if (arr[record.id].errorcode == 0 || arr[record.id].errorcode == null) {
                if (arr[record.id].errtime) {
                  let date = new Date().getTime() - new Date(arr[record.id].errtime).getTime()
                  hours = parseInt(date / (1000 * 60 * 60))
                } else {
                  let date = new Date().getTime() - new Date(arr[record.id].createdtime).getTime()
                  hours = parseInt(date / (1000 * 60 * 60))
                }
              } else {
                hours = 0
              }
              let wenk = self.devicTableData228.filter(x => {
                return x.projectid == arr[record.id].projectid
              })
              let imga = 'https://resource.mibee.cn/resource/' + (arr[record.id].pic || 'dba06208-8bcd-4bfa-9478-18ebcda63264')
              let name = arr[record.id].aio_project_name || arr[record.id].name
              var content = []
              content.push(
                "<div style='width: 8.75rem; height: 11rem;padding-top: 0.3rem; padding-bottom: 0.3rem;border: solid 1px #3F56BC;border-radius: 0.5rem; color: #ffffff;background-color: rgba(21,18,46,0.9);'><div style='font-size: 0.8rem'><span>" + name + "</span></div><div style='width: 7.75rem; height: 4.09rem;margin-top: 0.5rem; margin-bottom: 0.8rem'><img style='width: 7.75rem; height: 4.09rem;margin-left: 0.5rem' src=" + imga + "></div><div style='text-align:left; padding-left: 0.5rem; font-size: 0.75rem; margin-top: 0.44rem'><span>温控数量：" + wenk.length + "</span></div><div style='text-align:left; padding-left: 0.5rem;margin-top: 0.44rem;margin-bottom: 0.55rem; font-size: 0.75rem;'><span>已累计运行" + hours + '小时无故障</span></div></div>'
              )
              var infoWindow = new AMap.InfoWindow({
                isCustom: true,
                content: createInfoWindow(content.join('<br>')), // 传入 dom 对象，或者 html 字符串
                offset: new AMap.Pixel(18, -30)
              })
              infoWindow.open(map, record.data.position)
              // 构建自定义信息窗体
              function createInfoWindow (content) {
                var info = document.createElement('div')
                // 可以通过下面的方式修改自定义窗体的宽高
                info.style.width = '10.75rem'
                var middle = document.createElement('div')
                middle.innerHTML = content
                info.appendChild(middle)

                return info
              }
            }
          })
          markerList.on('markerMouseout', function (event, record) {
            var marker
            marker = record.marker
            if (record && marker) {
              map.clearInfoWindow()
            }
          })
          var arr1 = 0
          for (var D = 0; D < arr.length; D++) {
            if (arr[D].location != null) {
              let gaode1 = arr[D].location.split(',')[0]
              let gaode2 = arr[D].location.split(',')[1]
              self.deviceAddress[arr1] = {position: [gaode1, gaode2], id: D}
              arr1++
            }
          }
          let gaode1 = ''
          let gaode2 = ''
          if (self.default.location != null) {
            gaode1 = self.default.location.split(',')[0]
            gaode2 = self.default.location.split(',')[1]
          }
          self.deviceAddress[arr1] = {position: [gaode1 || 0, gaode2 || 0], id: 1000}
          var data = self.deviceAddress
          markerList.render(data)
        })
    },
    state () {
      myCharts = echarts.init(document.getElementById('main'))
      let arr = this.devicTableData.length
      let On = 0
      let Off = 0
      for (let i = 0; i < arr; i++) {
        if (this.devicTableData[i].power == 1) {
          On++
        } else {
          Off++
        }
      }
      myCharts.setOption(off(On, Off, arr))
      myCharts.resize()
    },
    state_1 () {
      myCharts_1 = echarts.init(document.getElementById('main_1'))
      let arr = this.devicTableData.length
      let On = 0
      let cold = 0
      let hot = 0
      for (let i = 0; i < arr; i++) {
        if (this.devicTableData[i].power == 1) {
          On++
          if (this.devicTableData[i].mode == 2 || this.devicTableData[i].mode == 4) {
            hot++
          } else {
            if (this.devicTableData[i].mode == 1 || this.devicTableData[i].mode == 3) {
              cold++
            }
          }
        }
      }
      myCharts_1.setOption(coldHot(cold, hot, On))
      myCharts_1.resize()
    },
    // 负荷预测
    loada (projectid) {
      var self = this
      let deviceAioD = []
      let deviceAioD1 = []
      myCharts_2 = echarts.init(document.getElementById('main_2'))
      Vue.axios.post('/project/device/aio', {
        // startdate: self.timestamp[0],
        startdate: self.value1[0],
        enddate: self.timestamp[1],
        deviceid: projectid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (res.data.msgbody) {
              let d = 0
              for (let i = 23; i < res.data.msgbody.length; i++) {
                deviceAioD1[d] = '-'
                if (res.data.msgbody[i].powerused < 0) {
                  deviceAioD[d] = 0
                  d++
                } else {
                  deviceAioD[d] = res.data.msgbody[i].powerused
                  d++
                }
              }
              deviceAioD1[deviceAioD.length - 1] = deviceAioD[deviceAioD.length - 1]
              for (let i = d; i < 24; i++) {
                deviceAioD1[i] = res.data.msgbody[i].powerused
              }
            } else {
              deviceAioD = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
              deviceAioD1 = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
            }

            myCharts_2.setOption(loadEcharts(deviceAioD, self.deviceTimeD, deviceAioD1, self.Z, self.L))
            myCharts_2.resize()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      // 昨天
      $('.yesterday').click(function () {
        Vue.axios.post('/project/device/aio', {
          startdate: self.value1[0],
          enddate: self.value1[1],
          deviceid: projectid
        })
          .then((res) => {
            if (res.data.errcode == 0) {
              if (res.data.msgbody) {
                for (let i = 0; i < res.data.msgbody.length; i++) {
                  if (res.data.msgbody[i].powerused < 0) {
                    self.deviceAioY[i] = 0
                  } else {
                    self.deviceAioY[i] = res.data.msgbody[i].powerused
                  }
                  let time = res.data.msgbody[i].createdtime.split(' ')
                  time = time[1].split(':')[0]
                  self.deviceTimeY[i] = time
                // console.log(self.deviceAio[i])
                }
              } else {
                self.deviceAioY = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
                self.deviceAioY1 = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
                self.deviceTimeY = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
              }

              self.Z = 1
              self.L = false
              myCharts_2.setOption(loadEcharts(self.deviceAioY, self.deviceTimeY, self.deviceAioY1, self.Z, self.L))
              myCharts_2.resize()
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
        $(this).css({'background-color': '#1C61FF', 'border-top': '0.47rem solid rgba(0, 8, 47, 0.8)', 'border-bottom': '0.47rem solid #001F8C'})
        $(this).siblings().css('background-color', '#001F8C')
        $('.tomorrow').css({'border-top': '0.47rem solid #001F8C', 'border-bottom': '0.47rem solid rgba(0, 8, 47, 0.55)'})
      })
      // 今天
      $('.today').click(function () {
        self.Z = 1
        self.L = true
        myCharts_2.setOption(loadEcharts(deviceAioD, self.deviceTimeD, deviceAioD1, self.Z, self.L))
        myCharts_2.resize()

        $(this).css({'background-color': '#1C61FF'})
        $(this).siblings().css('background-color', '#001F8C')
        $('.yesterday').css({'border-top': '0.47rem solid rgba(0, 8, 47, 0.55)', 'border-bottom': '0.47rem solid #001F8C'})
        $('.tomorrow').css({'border-top': '0.47rem solid #001F8C', 'border-bottom': '0.47rem solid rgba(0, 8, 47, 0.55)'})
      })
      // 上周
      $('.tomorrow').click(function () {
        Vue.axios.post('/project/device/aio', {
          startdate: self.tomorrow[0],
          enddate: self.tomorrow[1],
          deviceid: projectid
        })
          .then((res) => {
            if (res.data.errcode == 0) {
              if (res.data.msgbody) {
                for (let i = 0; i < res.data.msgbody.length; i++) {
                  if (res.data.msgbody[i].powerused < 0) {
                    self.deviceAioT[i] = 0
                  } else {
                    self.deviceAioT[i] = res.data.msgbody[i].powerused
                  }

                  let time = res.data.msgbody[i].createdtime.split(' ')
                  time = time[0].split('-')
                  time = time[1] + '/' + time[2]
                  self.deviceTimeT[i] = time
                  self.Z = 23
                }
              } else {
                self.Z = 0
                self.deviceAioT = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
                self.deviceAioT1 = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
                self.deviceTimeT = ['01', '02', '03', '04', '05', '06', '07']
              }
              self.L = false
              myCharts_2.setOption(loadEcharts(self.deviceAioT, self.deviceTimeT, self.deviceAioT1, self.Z, self.L))
              myCharts_2.resize()
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })

        $(this).css({'background-color': '#1C61FF', 'border-top': '0.47rem solid #001F8C', 'border-bottom': '0.47rem solid rgba(0, 8, 47, 0.8)'})
        $(this).siblings().css('background-color', '#001F8C')
        $('.yesterday').css({'border-top': '0.47rem solid rgba(0, 8, 47, 0.55)', 'border-bottom': '0.47rem solid #001F8C'})
      })
    },
    load () {
      var self = this
      self.mianji = self.devicTableData.length * 150
      for (let i = 0; i < self.devicTableData.length; i++) {
        self.devicTableDataInnerid[i] = self.devicTableData[i].projectid
      }
      Vue.axios.post('/project/device/aio', {
        startdate: self.timestamp[0],
        enddate: self.timestamp[1],
        deviceid: self.devicTableDataInnerid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (res.data.msgbody) {
              let deviceAioD = []
              for (let i = 0; i < res.data.msgbody.length; i++) {
                deviceAioD[i] = res.data.msgbody[i].powerused
              }
              var sum1 = 0
              for (let i = 0; i < deviceAioD.length; i++) {
                sum1 += deviceAioD[i]
              }
              self.sum = sum1.toFixed(0)
              self.sumN = (sum1 * 3600 * 0.85).toFixed(0)
            } else {
              self.sum = 0
              self.sumN = 0
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios.post('/project/device/total', {
        deviceid: self.devicTableDataInnerid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (res.data.msgbody) {
              self.deviceTotal = res.data.msgbody[0].total
              self.jieneng = (self.deviceTotal / 10).toFixed(2)
              self.jiantan = (self.jieneng * 0.785).toFixed(2)
              self.deviceTotal = (self.deviceTotal + '').split('')
            } else {
              self.jieneng = 0
              self.jiantan = 0
              self.deviceTotal = '0'
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios.post('/project/device/people', {
        projectid: self.devicTableDataInnerid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.people = res.data.msgbody[0].num
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    deviceErrcode () {
      var self = this
      let e = 0
      for (let i = 0; i < self.devicTableData.length; i++) {
        if (self.devicTableData[i].errorcode != null && self.devicTableData[i].errorcode != 0) {
          let time = self.devicTableData[i].createdtime.split('T')
          let time1 = time[1].split(':')
          let time2 = time[0] + ' ' + time1[0] + ':' + time1[1]
          self.tableData[e] = {'name': self.devicTableData[i].name, 'errmsg': self.devicTableData[i].errmsg, 'createdtime': time2}
          e++
        }
      }
    },
    project_list (projectid) {
      Vue.axios.post('/api/cchv/device/list', {
        projectid: projectid
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.deviceList = res.data.msgbody
            // let projectid = [this.Acb.innerid || this.heatpump.innerid]
            // console.log(this.Acb.innerid+'acb')
            // console.log(this.heatpump.innerid)
            // this.loada(projectid)
            this.draw()
          }
        })
    },
    draw () {
      const win_wid = window.innerWidth
      const co2list = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const humidList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const srList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4]
        ]
      ]

      const lwList = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const tempList = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const pm25List = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0]
        ]
      ]

      var c = document.getElementById('qlg')
      c.height = (win_wid / 1920) * 16 * 25.5
      c.width = (win_wid / 1920) * 16 * 22.5
      var ctx = c.getContext('2d')

      let colorlevel = 0
      let co2level = 0
      if (this.device_229.snrco2 < 700) {
        co2level = 0
      } else if (this.device_229.snrco2 < 1000) {
        co2level = 1
      } else if (this.device_229.snrco2 < 1500) {
        co2level = 2
      } else {
        co2level = 3
      }
      if (colorlevel < co2level) {
        colorlevel = co2level
      }

      let pm25level = 0
      if (this.device_229['snrpm2.5'] < 25) {
        pm25level = 0
      } else if (this.device_229['snrpm2.5'] < 37.5) {
        pm25level = 1
      } else if (this.device_229['snrpm2.5'] < 75) {
        pm25level = 2
      } else {
        pm25level = 3
      }
      if (colorlevel < pm25level) {
        colorlevel = pm25level
      }

      let templevel = 0
      if (Math.abs(this.device_229.snrtemp - 26) <= 2) {
        templevel = 0
      } else if (Math.abs(this.device_229.snrtemp - 26) <= 4) {
        templevel = 1
      } else if (Math.abs(this.device_229.snrtemp - 26) <= 6) {
        templevel = 2
      } else {
        templevel = 3
      }
      if (colorlevel < templevel) {
        colorlevel = templevel
      }

      let humidlevel = 0
      if (this.device_229.snrhumi >= 40 && this.device_229.snrhumi <= 60) {
        humidlevel = 0
      } else if (this.device_229.snrhumi >= 30 && this.device_229.snrhumi <= 70) {
        humidlevel = 1
      } else if (this.device_229.snrhumi >= 20 && this.device_229.snrhumi <= 80) {
        humidlevel = 2
      } else {
        humidlevel = 3
      }
      if (colorlevel < humidlevel) {
        colorlevel = humidlevel
      }

      let lwlevel = 0
      if (this.device_229.filterAused <= 60) {
        lwlevel = 0
      } else if (this.device_229.filterAused <= 105) {
        lwlevel = 1
      } else if (this.device_229.filterAused <= 150) {
        lwlevel = 2
      } else {
        lwlevel = 3
      }
      if (colorlevel < lwlevel) {
        colorlevel = lwlevel
      }
      if (colorlevel <= 1) {
        ctx.strokeStyle = '#41BB79'
      } else if (colorlevel == 2) {
        ctx.strokeStyle = '#F4C01C'
      } else {
        ctx.strokeStyle = '#E0510A'
      }

      ctx.lineWidth = 2
      ctx.moveTo(co2list[co2level][0][0], co2list[co2level][0][1])
      ctx.lineTo(co2list[co2level][1][0], co2list[co2level][1][1])
      ctx.lineTo(humidList[humidlevel][0][0], humidList[humidlevel][0][1])
      ctx.lineTo(humidList[humidlevel][1][0], humidList[humidlevel][1][1])
      ctx.lineTo(srList[0][0][0], srList[0][0][1])
      ctx.lineTo(srList[0][1][0], srList[0][1][1])
      ctx.lineTo(lwList[lwlevel][0][0], lwList[lwlevel][0][1])
      ctx.lineTo(lwList[lwlevel][1][0], lwList[lwlevel][1][1])
      ctx.lineTo(tempList[templevel][0][0], tempList[templevel][0][1])
      ctx.lineTo(tempList[templevel][1][0], tempList[templevel][1][1])
      ctx.lineTo(pm25List[pm25level][0][0], pm25List[pm25level][0][1])
      ctx.lineTo(pm25List[pm25level][1][0], pm25List[pm25level][1][1])
      ctx.lineTo(co2list[co2level][0][0], co2list[co2level][0][1])
      ctx.stroke()
    },
    buildWeatherReport_1 (city) {
      var self = this
      Vue.axios.post('/api/weather', { weaid: city})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.weather = res.data.msgbody
            myCharts_4 = echarts.init(document.getElementById('main_4'), 'shine')
            myCharts_4.setOption(buildPM25Report_1(self.weather.pm25, 'PM2.5'))
            myCharts_4.resize()
            self.gradeWord2 = self.weather.category
            for (var p = 0; p < pm25LvlRange.length; p++) {
              if (self.weather.pm25 <= pm25LvlRange[p]) {
                this.gradeColor2 = pm2d5LvlColorArray1[p - 1]
                break
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    handleCommand (key) {
      if (key === 'exit') {
        window.localStorage.clear()
        this.$router.push({ name: 'Login' })
      } else {
        if (key === 'adminDealer') {
          this.$router.push({ name: 'AdminDealer' })
        } else {
          if (key === 'Dealer') {
            if (this.level == 1) {
              this.$router.push({ name: 'DealerEdit' })
            } else {
              window.localStorage.setItem('AccountEdit', JSON.stringify(this.Username))
              this.$router.push({ name: 'AccountAdd' })
            }
          } else {
            if (key === 'password') {
              this.$router.push({ name: 'passwordEdit' })
            } else {
              this.$router.push({ name: 'ProjectList' })
            }
          }
        }
      }
    },
    getDpText: function (device, tag) {
      if (device.dplist) {
        let dp = device.dplist.filter((d) => {
          return d.name == tag
        })
        if (dp && dp.length > 0) {
          let t = dp[0].options.filter((o) => {
            return o.value == device[tag]
          })
          if (t && t.length > 0) {
            return t[0].text
          } else {
            return '--'
          }
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    }
  }
}
function off (On, Off, arr) {
  return {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      top: 'middle',
      // left: 'right',
      right: '0',
      orient: 'vertical',
      itemWidth: 8,
      itemHeight: 10,
      textStyle: {
        color: '#ffffff',
        fontSize: 12
      }
    },
    series: [
      {
        name: '开关机状态',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        left: '-45%',
        colorBy: 'data',
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '10',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: On,
            name: '开机' + ((On / arr) * 100).toFixed(0) + '%',
            itemStyle: {
              color: '#00EEFF'
            }},
          { value: Off,
            name: '关机' + ((Off / arr) * 100).toFixed(0) + '%',
            itemStyle: {
              color: '#FC7942'
            }}
        ]
      }
    ]
  }
}

function coldHot (cold, hot, On) {
  return {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      top: 'middle',
      // left: 'right',
      right: '5%',
      orient: 'vertical',
      itemWidth: 8,
      itemHeight: 10,
      textStyle: {
        color: '#ffffff',
        fontSize: 12
      }
    },
    series: [
      {
        name: '制冷热状态',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        left: '-45%',
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 10,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: cold,
            name: '制冷' + Math.round(cold / On * 100) + '%',
            itemStyle: {
              color: '#28b853'
            }},
          { value: hot,
            name: '制热' + Math.round(hot / On * 100) + '%',
            itemStyle: {
              color: '#FACD37'
            }}
        ]
      }
    ]
  }
}

function loadEcharts (y, x, Y, Z, L) {
  return {
    tooltip: {// 拐点提示框
      trigger: 'axis',
      backgroundColor: '#89b5f7',
      borderColor: '#89b5f7',
      padding: 5,
      textStyle: {
        color: '#FEFEFE'
      }
    },
    legend: {
      data: [
        {
          name: '实时',
          itemStyle: {
            color: '#2171FD'
          }
        },
        {
          name: '预测',
          itemStyle: {
            color: '#E65039'
          }
        }
      ],
      show: L,
      icon: 'rect',
      itemWidth: 20,
      itemHeight: 2,
      top: 12,
      textStyle: {
        color: '#ffffff',
        fontSize: 12
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: x,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#B4C6EC',
        interval: Z
      }
    },
    yAxis: [{
      type: 'value',
      position: 'left',
      name: 'kWh',
      // nameGap: 0,
      nameTextStyle: {// name 样式
        color: '#B4C6EC',
        fontSize: 12,

        padding: [0, 40, 0, 0]
      },
      // 刻度线样式
      axisLabel: {
        color: '#B4C6EC'
      },
      splitLine: {
        show: false
      }
    },
    {
      type: 'value',
      show: false,
      position: 'right'
    }],
    series: [{// 左折线图 电量
      name: '实时',
      data: y,
      smooth: true, // 修改折线为曲线
      symbol: 'none', // 去掉拐点
      itemStyle: {// 拐点样式
        normal: {
          color: '#2171FD'// 拐点颜色
        }
      },
      type: 'line',
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#00E6FC' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 238, 255, 0)' // 100% 处的颜色
            }
          ]) // 背景渐变色
        }
      },
      lineStyle: {
        width: 2,
        type: 'solid',
        color: '#2171FD' // 折线的颜色
      }
    },
    {// 左折线图 电量
      name: '预测',
      data: Y,
      smooth: true, // 修改折线为曲线
      symbol: 'none', // 去掉拐点
      itemStyle: {// 拐点样式
        normal: {
          color: '#ff0000'// 拐点颜色
        }
      },
      type: 'line',
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#e34343' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(227, 67, 67, 0)' // 100% 处的颜色
            }
          ]) // 背景渐变色
        }
      },
      lineStyle: {
        width: 2,
        type: 'solid',
        color: '#ff0000' // 折线的颜色
      }
    }],
    // 调整表格两边空白的区域
    grid: {
      // 左侧
      x: '11%',
      // 上部
      // y: '20%',
      // 右侧
      // x2: '20%',
      // 下部
      y2: '20%'
      // containLabel: true
    }
  }
}
function buildPM25Report_1 (data, title) {
  const win_wid = window.innerWidth
  var color = '#69CE03'
  if (title == 'PM2.5') {
    if (data <= 35) {
      color = '#69CE03'
    } else if (data <= 75) {
      color = '#FFD028'
    } else if (data <= 115) {
      color = '#FE8700'
    } else if (data <= 150) {
      color = '#FD0100'
    } else if (data <= 250) {
      color = '#CC0100'
    } else {
      color = '#960359'
    }
  }

  return {
    series: [
      {
        name: title,
        type: 'gauge',
        splitNumber: 60, // 刻度数量
        min: 0,
        max: 500,
        radius: '90%', // 图表尺寸
        center: ['50%', '50%'],
        startAngle: 230, // 刻度起始
        endAngle: -50, // 刻度结束
        axisLine: {
          show: false,
          lineStyle: {
            width: 0,
            shadowBlur: 0,
            color: [
              [data / 500, color],
              [1, 'rgb(122,120,172)']
            ]
          }
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: 'auto',
            width: 2
          },
          length: (win_wid / 1920) * 16 * 0.6,
          splitNumber: 1
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        pointer: {
          // 仪表盘指针
          show: 0
        },
        title: {
          show: false,
          offsetCenter: [0, '5%'], // x, y，单位px
          textStyle: {
            color: '#ddd',
            fontSize: (win_wid / 1920) * 16 * 0.75
          }
        },
        detail: {
          borderColor: '#fff',
          shadowColor: '#fff', // 默认透明
          shadowBlur: 2,
          offsetCenter: [0, '-5%'], // x, y，单位px
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#FFFFFF',
            fontSize: (win_wid / 1920) * 16 * 3
          },
          formatter: [
            '{name|' + title + '}',
            '{value}',
            title == 'PM2.5' ? '{unit|μg/m³}' : ''
          ].join('\n'),
          rich: {
            name: {
              fontSize: (win_wid / 1920) * 16 * 1,
              lineHeight: (win_wid / 1920) * 16 * 2.5,
              color: '#B4C6EC'
            },
            value: {
              lineHeight: (win_wid / 1920) * 16 * 4.1
            },
            unit: {
              fontSize: (win_wid / 1920) * 16 * 1,
              lineHeight: (win_wid / 1920) * 16 * 1.3,
              color: '#B4C6EC'
            }
          }
        },
        data: [
          {
            value: data
          }
        ]
      }
    ]
  }
}

Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<style scoped >
li {
    list-style: none;
}
.col23-8_1 {
  margin-top: 0.3rem;
  background: linear-gradient(to right, rgba(7, 60, 133, 0), rgba(5, 56, 136, 1) );
  height: 1.84rem;
  position: relative;
}
.col23-8_1 > div {
  width: 1.84rem;
  border-top: 1.84rem solid #053888;
  border-right: 1.84rem solid transparent;
  /* box-shadow: 0.3rem 0.3rem 1rem #053888; */
  position: absolute;
  top: 0;
  right: -2.5rem;
}
.col23-8_2 {
  height: 2.38rem;
  line-height:2.38rem;
  text-align: center;
  text-shadow: 0.1rem 0.1rem 1.1rem rgba(255, 255, 255, 0.4);
  font-size: 2.38rem;
  color: #FFFFFF;
  font-weight: Bold;
}
.col23-8_3 {
  margin-top: 0.3rem;
  background: linear-gradient(to right, rgba(5, 56, 136, 1), rgba(7, 60, 133, 0) );
  height: 1.84rem;
  position: relative;
}
.col23-8_3 > div {
  height: 1.84rem;
  width: 1.84rem;
  border-top: 1.84rem solid #053888;
  border-left: 1.84rem solid transparent;
  position: absolute;
  top: 0;
  left: -2.5rem;
}
.el-main {
  height: 37.5rem;
}

.el-col-5 {
  box-sizing: border-box;
  background-color: rgba(0, 8, 47, 0.66);
}
/* 综合信息 */
.biaoti {
  width: 100%;
  height: 2.25rem;
  text-align: center;
  line-height: 2.25rem;
  margin: 0 auto;
  text-align: center;
  color: #FFFFFF;
  font-size: 1.25rem;

  background-image: url("../../../static/images/biaoti.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.shichang {
  display: inline-block;
  width: 1.1  5rem;
  height: 2.3rem;
  line-height: 2.3rem;
  margin-right: 0.1rem;

  font-family: Rajdhani-SemiBold, Rajdhani;
  text-align: left;
  background-color: #002A7B;
  font-size: 1.8rem;
  color: #00EEFF;
}

.span_1 {
  height: 1.88rem;
  line-height: 1.88rem;
  text-align: center;
  color: #B4C6EC;
  font-size: 0.94rem;
}
.span_2 {
  height: 1.88rem;
  line-height: 1.88rem;
  text-align: left;
  color: #00EEFF;
  font-family: Rajdhani-SemiBold, Rajdhani;
  font-size: 1.5rem;
}
.span_2 span:nth-of-type(2) {
  color: #B4C6EC;
  font-size: 0.75rem;
}

/* 设备状态统计 */
.col5 {
  height: 37.5rem;
  background-color: transparent;
}
.col5 > .el-row {
  background-color: rgba(0, 8, 47, 0.66);
}
.state {
  font-size: 1.5rem;
  text-align: left;
}
.state span:nth-of-type(1) {
  display: inline-block;
  width: 0.31rem;
  height: 0.31rem;
}
.state_1 {
  font-size: 0.75rem;
  color: #B4C6EC;
  text-align: left;
}
.state_1 span:nth-of-type(1) {
  display: inline-block;
  width: 0.31rem;
  height: 0.31rem;
  background-color: #00EEFF;
  border-radius: 50% 50%;
  vertical-align: middle;
}

/* 负荷预测 */
.option {
  width: 1.69rem;
  position: absolute;
  left: 0;
  top: 3rem;
}
.option > div {
  box-sizing: border-box;
  height: 3.93rem;
  text-align: center;
  font-size: 0.75rem;
  color: #00E7EE;
}
.option > div > span {
    display: inline-block;
    width: 1.5rem;
    padding-top: 0.47rem;
}
.yesterday {
  background-color: #001F8C;
  border-top: 0.47rem solid rgba(0, 8, 47, 0.8);
  border-left: 1.69rem solid transparent;
  border-bottom: 0.47rem solid #001F8C;
  position: relative;
}
.yesterday span {
  position: absolute;
  left: -1.69rem;
}
.option .today {

  background-color: #1C61FF;
  border-top: 0.47rem solid #001F8C;
  border-right: 1.69rem solid transparent;
  border-bottom: 0.47rem solid #001F8C;
}
.tomorrow {
  background-color: #001F8C;
  border-top: 0.47rem solid #001F8C;
  border-left: 1.69rem solid transparent;
  border-bottom: 0.47rem solid rgba(0, 8, 47, 0.55);
  position: relative;
}
.tomorrow span {
  position: absolute;
  left: -1.69rem;
}

/* 项目运行状态 */
.yunxing {
  margin-top: 0.38rem;
  margin-left: 1.69rem;
  color: #B4C6EC;
  font-size: 0.94rem;
}
.yunxing > .el-row {
  margin-top: 0.2rem;
}
.yunxing > .el-row > .el-col-8:nth-of-type(1) {
  text-align: right;
  margin-right: 1rem;
}
.yunxing > .el-row > .el-col:nth-of-type(2){
  text-align: left;
  margin-left: 1.69rem;
}

/* 室内空气质量 */
.rightUpBody {
  width: 12.5rem;
  margin: 0;
  position: relative;
}

.dataGrade1 {
  width: 5.25rem;
  margin: 0 auto;
  border-radius: 0.93rem;
  text-align: center;
  font-size: 0.93rem;
  color: #fff;
  line-height: 1.25rem;
  height: 1.25rem;
  margin-top: -24%;
}
.col12 {
  width: 4.7rem;
  text-align: center;
}
.dataGrade2 {
  width: 4.7rem;
  border-radius: 0.65rem;
  text-align: center;
  font-size: 0.75rem;
  color: #fff;
  line-height: 0.95rem;
  height: 0.95rem;
}
.span_3 {
  font-size: 0.75rem;
  height: 1.06rem;
  line-height: 1.06rem;
  color: #B4C6EC;
}
.span_4 {
  font-size: 1.56rem;
  height: 1.56rem;
  line-height: 1.56rem;
  color: #FFFFFF;
  margin-bottom: 0.3rem;
}
.span_5 {
  height: 1.13rem;
  line-height: 1.13rem;
  font-size: 0.82rem;
  color: #4A5397;
  margin-left: 0.2rem;
}
.span_6 {
  height: 1.69rem;
  line-height: 2.5rem;
  font-size: 1.26rem;
  color: #FFFFFF;
}

/* 故障报警 */
.table >>> .el-table, .el-table__expanded-cell {
  background-color: transparent;
}
.table >>> .el-table th {
    background-color: transparent;
}
.table >>> .el-table tr {
    background-color: transparent!important;
}
.table >>>  .el-table--enable-row-transition .el-table__body td, .el-table .cell{
   background-color: transparent;
}
.el-table::before {
	 left: 0;
	 bottom: 0;
	 width: 100%;
	 height: 0px;
}
.table >>> .el-table--enable-row-transition .el-table__header-wrapper .has-gutter tr .el-table_1_column_1 .cell {
  text-align: left;
}
.table >>>  .el-table--enable-row-transition .el-table__body-wrapper .el-table_1_column_1 .cell{
  text-align: left;
}

.border1 {
  display: inline-block;
  width: 0.89rem;
  height: 0.89rem;
  background-color: transparent;
  border-top: 0.13rem solid #31C4FA;
  border-left: 0.13rem solid #31C4FA;
  border-radius: 0.19rem;
  position: absolute;
  top: -0.13rem;
  left: -0.13rem;
}
.border2 {
  display: inline-block;
  width: 0.89rem;
  height: 0.89rem;
  background-color: transparent;
  border-top: 0.13rem solid #31C4FA;
  border-right: 0.13rem solid #31C4FA;
  border-radius: 0.19rem;
  position: absolute;
  top: -0.13rem;
  right: -0.13rem;
}
.border3 {
  display: inline-block;
  width: 0.89rem;
  height: 0.89rem;
  background-color: transparent;
  border-bottom: 0.13rem solid #31C4FA;
  border-left: 0.13rem solid #31C4FA;
  border-radius: 0.19rem;
  position: absolute;
  bottom: -0.13rem;
  left: -0.13rem;
}
.border4 {
  display: inline-block;
  width: 0.89rem;
  height: 0.89rem;
  background-color: transparent;
  border-bottom: 0.13rem solid #31C4FA;
  border-right: 0.13rem solid #31C4FA;
  border-radius: 0.19rem;
  position: absolute;
  bottom: -0.13rem;
  right: -0.13rem;
}

.elrow {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Pandect.vue